export default "__VITE_ASSET__B3QY48sI__"